import getComplectations from '../../../api/cars/getComplectations';
import createComplectation from '../../../api/cars/createComplectation';
import getEngineCar from '../../../api/cars/getEngineCar';
import { ENGINE_TYPE_OPTIONS } from './carInfoInputs';

// ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ñ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ ÑÐ°Ð·Ð½ÑÐµ Ð½Ð° ÑÐ°Ð·Ð½ÑÑ ÐºÐ¾Ð½ÑÑÑÐ°Ñ (Â«ÐÐµÐ½Ð·Ð¸Ð½Â»,
// Â«ElectricÂ», Â«Ð­Ð»ÐµÐºÑÑÐ¸ÑÐµÑÐºÐ¸Ð¹Â»), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¸ÑÐµÐ¼ Ð¿Ð¾ ÑÐ¿Ð¸ÑÐºÑ ÑÐ¸Ð½Ð¾Ð½Ð¸Ð¼Ð¾Ð², Ð° Ð½Ðµ Ð¿Ð¾
// ÑÐ¾ÑÐ½Ð¾Ð¼Ñ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ.
const ENGINE_SYNONYMS = {
  PETROL: ['Ð±ÐµÐ½Ð·Ð¸Ð½', 'petrol', 'gasoline'],
  DIESEL: ['Ð´Ð¸Ð·ÐµÐ»Ñ', 'diesel'],
  GAS_PETROL: ['Ð³Ð°Ð·-Ð±ÐµÐ½Ð·Ð¸Ð½', 'Ð³Ð°Ð· Ð±ÐµÐ½Ð·Ð¸Ð½', 'gas-petrol'],
  GAS: ['Ð³Ð°Ð·', 'gas', 'lpg'],
  HYBRID: ['Ð³Ð¸Ð±ÑÐ¸Ð´', 'hybrid'],
  ELECTRIC: ['ÑÐ»ÐµÐºÑÑÐ¸ÑÐµÑÑÐ²Ð¾', 'ÑÐ»ÐµÐºÑÑÐ¸ÑÐµÑÐºÐ¸Ð¹', 'ÑÐ»ÐµÐºÑÑÐ¾', 'electric'],
};

const norm = (value) => String(value ?? '').trim().toLowerCase();

/** ÐÐ°Ð¿Ð¸ÑÑ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»ÐµÐ¹ Ð¿Ð¾Ð´ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð½Ð° ÑÐ¾ÑÐ¼Ðµ ÑÐ¸Ð¿. */
export const findEngine = (engines, engineType) => {
  const list = Array.isArray(engines) ? engines : [];
  const synonyms = ENGINE_SYNONYMS[engineType] || [];
  const byTitle = list.find((engine) => synonyms.includes(norm(engine?.title)));
  // ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½ÑÐ¹ ÑÐ¸Ð¿ Ð¸Ð»Ð¸ Ð¿ÑÑÑÐ¾Ð¹ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº: Ð±ÐµÑÑÐ¼ Ð¿ÐµÑÐ²ÑÐ¹, Ð¸Ð½Ð°ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ
  // ÑÐ¹Ð´ÑÑ Ñ engineId = 0 Ð¸ Ð±Ð°Ð½Ðº Ð¿Ð¾Ð»ÑÑÐ¸Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð±ÐµÐ· ÑÐ¸Ð¿Ð° ÑÐ¾Ð¿Ð»Ð¸Ð²Ð°.
  return byTitle || list[0] || null;
};

/** ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸-Ð·Ð°Ð³Ð»ÑÑÐºÐ¸: ÑÐ¾ Ð¶Ðµ, ÑÑÐ¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²ÑÐ±ÑÐ°Ð» Ð² Â«Ð¢Ð¸Ð¿Ðµ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»ÑÂ». */
export const complectationTitleFor = (engineType) =>
  ENGINE_TYPE_OPTIONS.find((option) => option.value === engineType)?.label || 'ÐÐ°Ð·Ð¾Ð²Ð°Ñ';

/**
 * ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð´Ð»Ñ ÐºÐ¾ÑÐ¾ÑÐºÐ¾Ð¹ ÑÐ¾ÑÐ¼Ñ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÐµÑ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼, Ð½Ð¾ Ð±ÐµÐ· Ð½ÐµÑ Ð°Ð²ÑÐ¾
 * Ð½Ðµ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð² ÑÐ´ÐµÐ»ÐºÑ â ÑÐ¸Ð¿ ÑÐ¾Ð¿Ð»Ð¸Ð²Ð°, Ð¾Ð±ÑÑÐ¼ Ð¸ ÐºÐ¾ÑÐ¾Ð±ÐºÑ Ð±Ð°Ð½ÐºÐ¸ Ð±ÐµÑÑÑ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð¾ÑÑÑÐ´Ð°.
 *
 * ÐÐ°Ð²Ð¾Ð´Ð¸Ð¼ Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¹ Ð½Ð° ÑÐ¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ Ð² Ð¿ÑÐµÐ´ÐµÐ»Ð°Ñ Ð¼Ð°ÑÐºÐ¸ Ñ Ð¼Ð¾Ð´ÐµÐ»ÑÑ Ð¸ Ð¿ÐµÑÐµÐ¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼:
 * Ð²ÑÐ¾ÑÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ñ ÑÐµÐ¼ Ð¶Ðµ ÑÐ¾Ð¿Ð»Ð¸Ð²Ð¾Ð¼ Ð½Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð½Ðµ ÑÐ¾Ð·Ð´Ð°ÑÑ.
 */
const ensureComplectation = async ({ containerId, engineType }) => {
  if (!containerId) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');

  const title = complectationTitleFor(engineType);
  const existing = await getComplectations({ containerId, used: true });
  const found = (existing?.data || []).find((item) => norm(item?.title) === norm(title));
  if (found?.id) return found.id;

  const engines = await getEngineCar();
  const engine = findEngine(engines?.data, engineType);

  const created = await createComplectation({
    title,
    containerId,
    used: true,
    engineId: engine?.id ?? 1,
    // ÐÑÐ·Ð¾Ð² Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´ Ð½Ð° ÐºÐ¾ÑÐ¾ÑÐºÐ¾Ð¹ ÑÐ¾ÑÐ¼Ðµ Ð½Ðµ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ â ÑÑÐ°Ð²Ð¸Ð¼ ÑÐµ Ð¶Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ,
    // ÑÑÐ¾ Ð¸ ÑÑÑÐ½Ð¾Ðµ Ð·Ð°Ð²ÐµÐ´ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð² ÑÐµÐ»ÐµÐºÑÐµ.
    carcaseId: 1,
    wdId: 2,
  });
  const id = Number(created?.data);
  if (!id) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð´Ð¾Ð±ÑÐ°ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ');
  return id;
};

export default ensureComplectation;
